module.exports = __webpack_public_path__ + "static/img/14000125.30e9cb91.png";